<template>
  <div
    class="button"
    @click="buttonClick"
  >
    <span class="cta">{{ label }}</span>
  </div>
</template>

<script setup lang="ts">
  interface Props {
    label: string
    disabled?: boolean
  }

  const props = withDefaults(defineProps<Props>(), {
    disabled: false
  })

  const emits = defineEmits(['clicked'])

  function buttonClick() {
    if (!props.disabled) emits('clicked')
  }
</script>

<style lang="scss" scoped>
  @import '~/assets/styles/common.scss';

  .button {
    align-items: center;
    border: 1px solid $ui-dark-blue;
    border-radius: 4px;
    cursor: pointer;
    width: auto;
    padding: rem(16) rem(32);
    text-align: center;
    box-sizing: border-box;

    &.blue {
      background-color: $ui-dark-blue;
      color: $white;
      max-width: fit-content;

      &.arrow-right {
        padding-bottom: rem(18);

        span {
          &:after {
            content: url('~/assets/icons/arrow-right-green.png');
            position: relative;
            left: 14px;
            top: 4px;
          }
        }
      }

      &.disabled {
        background-color: $secondary;
        border-color: $border-grey;
      }
    }

    &.green {
      background-color: $bt-green;
      border: 1px solid $bt-green;
      color: $bt-blue;
    }

    &.outlined {
      background-color: $white;
      color: $ui-dark-blue;
    }

    &.clear {
      background-color: transparent;
      border: 0;
      color: $ui-light-blue;
      text-decoration: underline;

      .cta {
        @include mobile {
          font-weight: 400;
          font-size: rem(16);
          line-height: rem(24);
        }
      }

      @include tablet-up {
        background-color: $white;
        color: $ui-dark-blue;
      }
    }

    &.wide {
      @include tablet-up {
        min-width: 200px;
      }
    }
  }
</style>
